import React from 'react';
import { Col, DatePicker, Form, Input, Row, Select, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const InfoSection = ({
  shoppingCenters,
  selectMarcoArea,
  academyCategories,
}) => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Informazioni Generali')}</Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Titolo')} name='title'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Outlet Village')} name='shopping_center_id'>
          <Select placeholder={t('Selezioni opzione')}>
            <Select.Option value={''}>{t('Selezioni opzione')}</Select.Option>
            {shoppingCenters.map((i) => (
              <Select.Option value={i.id}>{i.title}</Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col offset={6} span={9}>
        <Form.Item label={t('Modulo')} name='academy_category_id'>
          <Select placeholder={t('Selezioni opzione')}>
            <Select.Option value={''}>{t('Selezioni opzione')}</Select.Option>
            {academyCategories.map((i) => (
              <Select.Option value={i.id}>{i.title}</Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Data Pubblicazione')} name='date'>
          <DatePicker format={'DD MMMM YYYY'} />
        </Form.Item>
      </Col>
      <Col offset={6} span={9}>
        <Form.Item label={t('Macro-Area')} name='macro_area'>
          <Select placeholder={t('Selezioni opzione')}>
            <Select.Option value={''}>{t('Selezioni opzione')}</Select.Option>
            {selectMarcoArea.map((i) => (
              <Select.Option key={i} value={i}>
                {i}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(InfoSection);
